import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine, faChartSimple } from "@fortawesome/free-solid-svg-icons";
import { ThemeContext } from "../../../context/ThemeContext";
import img3 from "../../../assets/Dashboard.png";
import "../../../pages/Landing/LandingPage.css";

const About = () => {
  const { darkMode } = useContext(ThemeContext);

  return (
    <section
      className={`about-new-section py-5 ${darkMode ? "dark-mode" : ""}`}
      id="about-new"
    >
      <div className="container">
        <div className="row text-center mb-5">
          <div className="col-12">
            <h2 className="about-main-title">Grow Your Business With Us</h2>
            <p className="about-subtitle">
              Discover how our comprehensive accounting solutions can help take
              your business to the next level
            </p>
          </div>
        </div>

        <div className="row g-5 align-items-center about-content-row">
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
            <div
              className={`about-content ${
                darkMode ? "dark-about-content" : ""
              }`}
            >
              <h3
                className={`about-heading ${darkMode ? "dark-mode-text" : ""}`}
              >
                Powerful Dashboard For Data-Driven Decisions
              </h3>
              <p
                className={`about-text ${
                  darkMode ? "dark-mode-text-secondary" : ""
                }`}
              >
                Our comprehensive dashboard gives you a complete overview of
                your business performance. Track real-time analytics, monitor
                revenue trends, and stay on top of pending payments - all from a
                single, intuitive interface designed to help you make informed
                decisions quickly.
              </p>

              <div className="about-features">
                <div
                  className={`about-feature-item ${
                    darkMode ? "dark-feature-item" : ""
                  }`}
                >
                  <div
                    className={`feature-icon-box ${
                      darkMode ? "dark-feature-icon-box" : ""
                    }`}
                  >
                    <FontAwesomeIcon icon={faChartLine} />
                  </div>
                  <div className="feature-content">
                    <h5
                      className={`feature-heading ${
                        darkMode ? "dark-mode-text" : ""
                      }`}
                    >
                      Financial Analytics & Reporting
                    </h5>
                    <p
                      className={`feature-text ${
                        darkMode ? "dark-mode-text-secondary" : ""
                      }`}
                    >
                      Visualize your business performance with interactive
                      charts showing invoice status, monthly revenue trends, and
                      daily cash flow. Our dashboard transforms complex
                      financial data into actionable insights.
                    </p>
                  </div>
                </div>

                <div
                  className={`about-feature-item ${
                    darkMode ? "dark-feature-item" : ""
                  }`}
                >
                  <div
                    className={`feature-icon-box ${
                      darkMode ? "dark-feature-icon-box" : ""
                    }`}
                  >
                    <FontAwesomeIcon icon={faChartSimple} />
                  </div>
                  <div className="feature-content">
                    <h5
                      className={`feature-heading ${
                        darkMode ? "dark-mode-text" : ""
                      }`}
                    >
                      Customer & Payment Tracking
                    </h5>
                    <p
                      className={`feature-text ${
                        darkMode ? "dark-mode-text-secondary" : ""
                      }`}
                    >
                      Monitor customer statistics, pending payments, and invoice
                      status in real-time. Stay on top of partially paid
                      invoices, track payment trends, and identify revenue
                      opportunities at a glance.
                    </p>
                  </div>
                </div>
              </div>

              <a
                href="#"
                className={`about-cta-btn ${
                  darkMode ? "dark-mode-btn-primary" : ""
                }`}
              >
                See All Features
              </a>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about-img-container">
              <img
                className="img-fluid rounded shadow wow zoomIn"
                data-wow-delay="0.5s"
                src={img3}
                alt="Interactive Business Dashboard"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
